import { render, staticRenderFns } from "./sfc-button.vue?vue&type=template&id=4b48cc65&scoped=true&lang=pug&"
import script from "./sfc-button.vue?vue&type=script&lang=js&"
export * from "./sfc-button.vue?vue&type=script&lang=js&"
import style0 from "./sfc-button.vue?vue&type=style&index=0&id=4b48cc65&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b48cc65",
  null
  
)

export default component.exports